import { useTranslation } from 'react-i18next'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

type LanguageSelectVariant = 'header' | 'panel'

interface LanguageSelectProps {
  variant?: LanguageSelectVariant
  className?: string
}

function currentLanguageCode(language: string) {
  return language.startsWith('id') ? 'id' : 'en'
}

export function LanguageSelect({ variant = 'panel', className }: LanguageSelectProps) {
  const { t, i18n } = useTranslation()
  const value = currentLanguageCode(i18n.language)

  return (
    <Select value={value} onValueChange={(lang) => void i18n.changeLanguage(lang)}>
      <SelectTrigger
        aria-label={t('welcome.chooseLanguage')}
        className={`prod-lang-select__trigger prod-lang-select__trigger--${variant}${className ? ` ${className}` : ''}`}
      >
        {variant === 'header' ? (
          <>
            <span className="prod-lang-select__code">{value === 'id' ? 'ID' : 'EN'}</span>
            <span className="prod-lang-select__name">
              <SelectValue />
            </span>
          </>
        ) : (
          <>
            <span className="prod-lang-select__code">{value === 'id' ? 'ID' : 'EN'}</span>
            <span className="prod-lang-select__name">
              <SelectValue />
            </span>
          </>
        )}
      </SelectTrigger>
      <SelectContent
        className={`prod-lang-select__content prod-lang-select__content--${variant}`}
        position="popper"
        sideOffset={4}
      >
        <SelectItem value="en" className="prod-lang-select__item">
          {t('common.english')}
        </SelectItem>
        <SelectItem value="id" className="prod-lang-select__item">
          {t('common.indonesian')}
        </SelectItem>
      </SelectContent>
    </Select>
  )
}
